/**
 * Study-queue time estimates.
 *
 * Topic cards deliberately show *content size* (how many questions, how many
 * words) rather than a level and a duration: a rolled-up Beginner/Advanced
 * label was mostly noise — most public sessions carry no real per-question
 * rating — and an invented "~N min" is a number nobody should plan a lesson
 * around. Both were removed from every topic surface.
 *
 * What remains is the one estimate that still earns its place: the home page's
 * review reminder, where "about N min" is the difference between opening the
 * review queue now and putting it off again.
 */

export const MINUTES_PER_ITEM = 1.5;

/**
 * Rough time to clear a study queue, in minutes.
 *
 * Deliberately rough, and rounded up, because it is only ever shown next to a
 * count as "about N min" — a hedge on the hint, not a promise. Returns 0 for
 * an empty queue so callers can omit the hint entirely rather than print
 * "about 0 min".
 */
export const estimateSessionMinutes = (itemCount: number): number => {
  if (itemCount <= 0) return 0;
  return Math.max(1, Math.round(itemCount * MINUTES_PER_ITEM));
};
